export const pluralize = (word, number) => {
    if (number > 1) {
      if (word.split('')[word.length - 1] === 'r') {
        return number + ' ' + word + 'es'
      }
      else {
        return number + ' ' + word + 's'
      }
    }
    else return number + ' ' + word
  }